// extracted by mini-css-extract-plugin
export var active = "bG_bd";
export var heading = "bG_G";
export var label = "bG_cX";
export var nodeContainer = "bG_gP";
export var section = "bG_d";
export var video = "bG_f4";
export var videos = "bG_gN";